export default [
  {
    path: 'gestao/produtos',
    name: 'produtos',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: false,
      title: 'Produtos',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Gestão', link: 'gestao' },
        { name: 'Produtos' }
      ]
    }
  },
]